import axios from "axios";
import InputGroup from "components/common/InputGroup";
import Icon from "components/Icons/Icon";
import { useState } from "react";

const ROLE_OPTIONS = [
  "Travel agent or agency",
  "Tour operator or DMC",
  "Travel content creator",
  "Travel blogger or influencer",
  "Other travel professional",
];

const CreatorSignup = ({ type }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [website, setWebsite] = useState("");
  const [role, setRole] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (name !== "" && email !== "") {
      axios
        .post("/api/utils/subscribers/creatorsignup", { name, email, website, role, business_type: type })
        .then(() => {
          setSubmitted(true);
        })
        .catch((err) => {
          console.error("[CreatorSignup] Submit failed:", { error: err?.message || err });
        });
    }
  };

  if (submitted) {
    return (
      <div className="signup-success">
        <div className="icon-rounded">
          <Icon name="check" />
        </div>
        <h3>Thank you for signing up!</h3>
        <p>We will get back to you as soon as possible.</p>
      </div>
    );
  }

  return (
    <div className="creator-signup">
      <div className="creator-signup__trial">
        <h3>Start your free trial</h3>
        <p className="creator-signup__subhead">Try it free and see if it's the right fit for you.</p>
        <a className="creator-signup__cta" href="/business/pricing">
          Start free trial <span aria-hidden="true">→</span>
        </a>
      </div>

      <div className="creator-signup__divider">
        <span>or talk to the team first</span>
      </div>

      <p className="creator-signup__helper">
        Not sure if Stippl is right for you? Leave your details and we'll reach out for a quick chat.
      </p>

      <form onSubmit={onSubmit} className="creator-signup__form">
        <InputGroup
          id="creator-name"
          dataTestid="creator-name"
          label="Name"
          placeholder="Your name"
          //@ts-ignore
          onChange={(e) => setName(e.target.value)}
        />
        <InputGroup
          id="creator-email"
          dataTestid="creator-email"
          label="Email"
          placeholder="you@example.com"
          //@ts-ignore
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="input-container-wrapper regular">
          <div className="label">
            <label htmlFor="creator-role">I am a...</label>
          </div>
          <div className="input-container">
            <select
              id="creator-role"
              name="creator-role"
              className="creator-signup__select"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="" disabled>
                Select your role
              </option>
              {ROLE_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
        <InputGroup
          id="creator-website"
          dataTestid="creator-website"
          label="Website or social link"
          placeholder="https://"
          //@ts-ignore
          onChange={(e) => setWebsite(e.target.value)}
        />

        <button type="submit" className="creator-signup__submit">
          Get in touch
        </button>
        <p className="creator-signup__footnote">We'll get back to you within one business day.</p>
        <p className="creator-signup__footnote">
          We use your details to follow up on your request. See our{" "}
          <a id="creator-privacy-link" href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </p>
      </form>
    </div>
  );
};

export default CreatorSignup;
